import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import * as util from 'notebook/tables/excess/Util';
import divide from 'notebook/tables/excess/util/divide';

export default {
  name: 'FLOOR',
  category: FunctionCategory.MATH,
  shortDescription: 'Rounds number down to nearest multiple of a factor.',
  description: 'Rounds a number down to the nearest integer multiple of specified significance.',
  params: [
    {
      name: 'value',
      type: ArgType.number,
      description: 'The value to round down to the nearest integer multiple of factor.',
    },
    {
      name: 'factor',
      type: ArgType.number,
      optional: true,
      description: 'The number to whose multiples value will be rounded. Equals 1 if not specified.',
    },
  ],
  eval: (value: number, factor?: number): number => {
    factor ??= 1;
    if (factor < 0 && value > 0) {
      throw new util.NumericalError('FLOOR parameter 1 must be negative if parameter 2 is negative');
    }
    if (factor === value && value === 0) {
      return 0;
    }
    return Math.floor(divide(value, factor)) * factor;
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
